import { FaUtensils, FaMobileAlt, FaChild, FaConciergeBell, FaCashRegister, FaBuilding } from 'react-icons/fa';

// Business channels for the Menu section. Dine-In has its own templates and daily menu (DINEIN).
export const MENU_CHANNELS = [
    { key: 'dinein', label: 'Dine-In', icon: FaUtensils, type: 'online', source: 'DINEIN' },
    { key: 'myeats', label: 'My Eats', icon: FaMobileAlt, type: 'online', source: 'MYEATS' },
    { key: 'jreats', label: 'Jr Eats', icon: FaChild, type: 'online', source: 'JREATS' },
    { key: 'catering', label: 'Catering', icon: FaConciergeBell, type: 'catering', source: 'MYEATS' },
];

export const DEFAULT_MENU_CHANNEL = 'myeats';

export function getMenuChannel(key) {
    return (
        MENU_CHANNELS.find((c) => c.key === key) ||
        MENU_CHANNELS.find((c) => c.key === DEFAULT_MENU_CHANNEL)
    );
}

// Order channels for the Orders section. Dine-In uses the "offline" order type.
export const ORDER_CHANNELS = [
    { key: 'offline', label: 'Dine-In', icon: FaUtensils },
    { key: 'myeats', label: 'My Eats', icon: FaMobileAlt },
    { key: 'jreats', label: 'Jr Eats', icon: FaChild },
    { key: 'catering', label: 'Catering', icon: FaConciergeBell },
    { key: 'partyHall', label: 'Party Hall', icon: FaBuilding },
];

export const DEFAULT_ORDER_CHANNEL = 'offline';

/** Delivery agent: MYEATS vs JREATS in employee sidebar (restaurant context). */
export const DELIVERY_AGENT_ORDER_SOURCES = [
    { key: 'MYEATS', label: 'MYEATS', icon: FaMobileAlt },
    { key: 'JREATS', label: 'JREATS', icon: FaChild },
];

/** Delivery agent in supermarket: MYEATS vs Restaurant orders. */
export const STORE_DELIVERY_AGENT_ORDER_SOURCES = [
    { key: 'MYEATS', label: 'MYEATS', icon: FaMobileAlt },
    { key: 'RESTAURANT', label: 'Company', icon: FaUtensils },
];

export const DEFAULT_DELIVERY_AGENT_ORDER_SOURCE = 'MYEATS';

export function getDeliveryAgentOrderSources(isStore = false) {
    return isStore ? STORE_DELIVERY_AGENT_ORDER_SOURCES : DELIVERY_AGENT_ORDER_SOURCES;
}

// Accepts URL order-type values (legacy "online" maps to My Eats).
export function getOrderChannel(key) {
    const normalized =
        key === 'online'
            ? 'myeats'
            : key === 'party-hall' || key === 'party_hall'
              ? 'partyHall'
              : key;
    return (
        ORDER_CHANNELS.find((c) => c.key === normalized) ||
        ORDER_CHANNELS.find((c) => c.key === DEFAULT_ORDER_CHANNEL)
    );
}

/** Order channels for store Orders sidebar (POS / My Eats / Restaurant). */
export const STORE_ORDER_CHANNELS = [
    { key: 'pos', label: 'POS', icon: FaCashRegister },
    { key: 'myeats', label: 'My Eats', icon: FaMobileAlt },
    { key: 'restaurant', label: 'Company', icon: FaUtensils },
];

export const DEFAULT_STORE_ORDER_CHANNEL = 'pos';

export function getStoreOrderChannel(key) {
    const normalized =
        key === 'online'
            ? 'myeats'
            : key === 'offline' || key === 'catering' || key === 'partyHall'
              ? 'pos'
              : key === 'jreats'
                ? 'restaurant'
                : key;
    return (
        STORE_ORDER_CHANNELS.find((c) => c.key === normalized) ||
        STORE_ORDER_CHANNELS.find((c) => c.key === DEFAULT_STORE_ORDER_CHANNEL)
    );
}

/** True when a store grocery order was placed by a restaurant (Company API). */
export function isRestaurantStoreOrderSource(source) {
    const norm = String(source ?? '').trim().toUpperCase();
    return norm === 'RESTAURANT' || norm === 'COMPANY';
}

/** Map store order source (POS / MYEATS / COMPANY) to sidebar channel key. */
export function storeOrderSourceToChannel(source) {
    const norm = String(source ?? '').trim().toUpperCase();
    if (norm === 'MYEATS') return 'myeats';
    if (isRestaurantStoreOrderSource(norm)) return 'restaurant';
    return 'pos';
}

/** Map restaurant order row to sidebar order channel (offline / myeats / jreats / catering). */
export function resolveRestaurantOrderChannel(orderDetails, locationState = {}) {
    const fromOrderView = locationState?.fromOrderView;
    const orderSourceNorm = String(
        orderDetails?.order_source ??
            orderDetails?.Order_Source ??
            orderDetails?.orderSource ??
            ''
    ).toUpperCase();
    const orderTypeNorm = String(
        orderDetails?.order_type ??
            orderDetails?.Order_Type ??
            orderDetails?.orderType ??
            ''
    )
        .toUpperCase()
        .replace(/[\s_-]+/g, '');

    if (
        fromOrderView === 'partyHall' ||
        orderDetails?.orderType === 'partyHall' ||
        orderDetails?.partyHallQuoteId
    ) {
        return 'partyHall';
    }
    if (orderSourceNorm === 'JREATS') {
        return 'jreats';
    }
    if (
        fromOrderView === 'online' ||
        orderSourceNorm === 'MYEATS' ||
        orderTypeNorm === 'DELIVERY' ||
        orderTypeNorm === 'PICKUP'
    ) {
        return 'myeats';
    }
    if (
        fromOrderView === 'catering' ||
        String(orderDetails?.orderType || '').toLowerCase() === 'catering'
    ) {
        return 'catering';
    }
    if (fromOrderView === 'offline') {
        return 'offline';
    }
    return 'offline';
}
